module.exports = __webpack_public_path__ + "img/img7.97d4c46b.png";